import { render } from "./Vue.vue.js?vue&type=template&id=3eccd59b!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Vue.vue?vue&type=template&id=3eccd59b"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__